import authRoutes from './authRoutes';
import onboardingRoutes from './onboardingRoutes';
import feedRoutes from './feedRoutes';
import lastRoutes from './lastRoutes';
import postRoutes from './postRoutes';
import ProtectedRoute from '../components/common/protectedRoute';
import authlessRoutes from './authlessRoutes';
import { footerRoutes } from '../utils/homeUtils';
import marsRoutes from './marsRoutes';

function makeProtected(routes) {
  routes.forEach((route) => (route.route = ProtectedRoute));
  return routes;
}
export default [
  ...authRoutes,
  ...onboardingRoutes,
  ...makeProtected(feedRoutes),
  ...makeProtected(postRoutes),
  ...authlessRoutes,
  ...footerRoutes,
  ...makeProtected(marsRoutes),
  ...lastRoutes, // last routes always should be last.
];
